import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
const testimonials = [{
  quote: "Solía sudar frío antes de cada Daily Scrum. Usé el script de 'Validación' del capítulo 2 y por primera vez sentí que tenía el control de la llamada.",
  author: 'Mateo V.',
  role: 'Diseñador UX'
}, {
  quote: 'Es como tener un manual de instrucciones para personas. Por fin entiendo cómo interactuar sin sentir que me estoy agotando socialmente en los primeros 10 minutos.',
  author: 'Laura S.',
  role: 'Junior Dev'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function TestimonialsSection() {
  return <section className="py-20 md:py-32 px-6 max-w-4xl mx-auto" data-id="element-66">
      <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true
    }} className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-67">
        {testimonials.map((testimonial, index) => <motion.div key={index} variants={itemVariants} className="p-8 rounded-3xl bg-gray-50 border border-gray-100 relative" data-id="element-68">
            <QuoteIcon className="w-10 h-10 text-gray-200 absolute top-6 right-6" data-id="element-69" />
            <div className="flex gap-1 mb-6" data-id="element-70">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-black text-black" data-id="element-71" />)}
            </div>
            <p className="text-lg text-gray-800 leading-relaxed mb-8 font-medium" data-id="element-72">
              "{testimonial.quote}"
            </p>
            <div data-id="element-73">
              <p className="font-bold text-black" data-id="element-74">{testimonial.author}</p>
              <p className="text-gray-500 text-sm" data-id="element-75">{testimonial.role}</p>
            </div>
          </motion.div>)}
      </motion.div>
    </section>;
}